export const EnviromentUrls = {
    beta: {
        "caipirinha": "https://api-beta.streamelements.com",
        "jagermeister": "https://beta.streamelements.com",
        "helixWebSocket": "helix-beta.streamelements.com",
        "home": "https://beta.streamelements.com",
        "madMen": "https://mad-men.staging.streamelements.com/api/v1"
    },
    local: {
        "caipirinha": "http://localhost:9000",
        "jagermeister": "http://localhost:3000",
        "helixWebSocket": "ws://localhost:9901",
        "home": "http://localhost:8080",
        "madMen": "https://mad-men.staging.streamelements.com/api/v1"
    },
    production: {
        "caipirinha": "https://api.streamelements.com",
        "jagermeister": "https://streamelements.com",
        "helixWebSocket": "wss://twitchstats-ws.streamelements.com",
        "home": "https://streamelements.com",
        "madMen": "https://mad-men.streamelements.com/api/v1"
    },
    staging: {
        "caipirinha": "http://localhost:9000",
        "jagermeister": "http://localhost:3000",
        "helixWebSocket": "helix.staging.streamelements.com",
        "home": "http://localhost:8080",
        "madMen": "https://mad-men.staging.streamelements.com/api/v1"
    }
};



// WEBPACK FOOTER //
// ./src/constants/EnviromentUrls.js